import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector     : 'carded-fullwidth-content-scroll',
    templateUrl  : './fullwidth.component.html',
    encapsulation: ViewEncapsulation.None
})
export class CardedFullwidthContentScrollComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
